module.exports = __webpack_public_path__ + "img/zeigling2.9e40b85c.jpg";